import classNames from 'classnames';
import { memo, useState, useRef, MouseEvent } from 'react';

import { SelectArrowIcon } from '@gem/icons';
import { Popover } from '@gem/ui-kit';

import styles from './DropDown.styles.m.css';
import { IDropDownProps } from './DropDown.types';
import { DropDownOptions } from './DropDownOptions/DropDownOptions';

export const DropDown = memo<IDropDownProps>((props) => {
  const {
    className,
    input: { onChange, value },
    meta: { error },
    label,
    options = [],
    noSelectedLabel,
  } = props;
  const [isListVisible, setListVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const containerClass = classNames(styles.container, className);

  const onClick = (event: MouseEvent<HTMLDivElement>): void => {
    event.stopPropagation();
    setListVisible(!isListVisible);
  };

  const onClose = (): void => setListVisible(false);

  const selectedOption = options.find((option) => option.value === value);

  return (
    <>
      <div
        ref={ref}
        role="button"
        tabIndex={0}
        className={containerClass}
        onClick={onClick}
      >
        <div className={styles.value}>{selectedOption ? selectedOption.label : label}</div>
        <SelectArrowIcon className={styles.arrow} />
      </div>
      <div className={styles.helperText}>{error}</div>
      <Popover
        isScrollEnabled
        isOpened={isListVisible}
        onClose={onClose}
        reference={ref.current}
        placement="bottom-start"
      >
        <DropDownOptions
          noSelectedLabel={noSelectedLabel}
          onChange={onChange}
          onClose={onClose}
          value={value}
          options={options}
        />
      </Popover>
    </>
  );
});
